import ColorfulRcItem from './colorful-rcItem';
export default ColorfulRcItem;
